// extracted by mini-css-extract-plugin
export default {"root":"talent-portal-trade-desk_root__ui9m4"};